import { Action } from '@ngrx/store';
import {
    Geofence,
    PlannedRide,
    TrackedRide,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { Collection } from 'src/app/models/collection';
import { SelectedItems } from 'src/app/models/selectedItems';

export const UserContentAction = {
    clearSelectedUserContentIds:
        '[user content] clear selected user content ids',
    setSelectedItems: '[user content] set selected items',
    toggleCollection: '[user content] toggle collection id',
    toggleGeofence: '[user content] toggle geofence id',
    togglePlannedRide: '[user content] toggle planned ride id',
    toggleTrackedRide: '[user content] toggle tracked ride id',
    toggleWaypoint: '[user content] toggle waypoint id',
};

export class ClearSelectedUserContentIds implements Action {
    type = UserContentAction.clearSelectedUserContentIds;
}

export class SetSelectedItems implements Action {
    type = UserContentAction.setSelectedItems;
    constructor(public selectedItems: SelectedItems) {}
}

export class ToggleCollection implements Action {
    type = UserContentAction.toggleCollection;
    constructor(public item: Collection) {}
}

export class TogglePlannedRide implements Action {
    type = UserContentAction.togglePlannedRide;
    constructor(public item: PlannedRide) {}
}

export class ToggleWaypoint implements Action {
    type = UserContentAction.toggleWaypoint;
    constructor(public item: Waypoint) {}
}

export class ToggleTrackedRide implements Action {
    type = UserContentAction.toggleTrackedRide;
    constructor(public item: TrackedRide) {}
}

export class ToggleGeofence implements Action {
    type = UserContentAction.toggleGeofence;
    constructor(public item: Geofence) {}
}
